import { useState } from "react";
// Components
import { StaffCardForm } from "../../pages/StaffCard/StaffCardForm";
// MUI
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function NewStaffDialog() {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant="outlined" onClick={handleClickOpen}>
        Add New Staff Member
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add New Staff</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Use the form below to create a new staff member to add to your
            order.
          </DialogContentText>
          <StaffCardForm newStaff isModal handleModalClose={handleClose} />
        </DialogContent>
      </Dialog>
    </>
  );
}
